
export const uploadsUrl = process.env.CONTENT_URL || 'https://uploads.az-warsaw-rfp.hlxcongress.digital'
export const contentUrl = `${uploadsUrl}/content`
export const assetsUrl = `${uploadsUrl}/assets`
export const videoContentUrl = `${contentUrl}/videos`
export const pdfContentUrl = `${contentUrl}/pdfs`
export const pdfViewer = `/pdf/web/viewer.html?file=`
